import {Component} from '@angular/core';
import {FormControl} from '@angular/forms';
import {ICellRendererAngularComp} from 'ag-grid-angular';
import {ICellRendererParams} from 'ag-grid-community';
import {ObjectCellRendererParams} from './object-cell-renderer-params.interface';

@Component({
  templateUrl: './object-cell-renderer.component.html',
  styleUrls: ['./object-cell-renderer.component.scss']
})
export class ObjectCellRendererComponent implements ICellRendererAngularComp {
  public formControl: FormControl;
  public multiple: boolean;
  public objectName: string = '';
  public params: ObjectCellRendererParams;

  public agInit(params: ObjectCellRendererParams): void {
    this.params = params;
    this.multiple = params.multiple ?? false;
    this.objectName = this.params.colDef?.headerName.toLowerCase() ?? '';
    this.formControl = new FormControl({value: params.value, disabled: true});
  }

  public refresh(_: ICellRendererParams): boolean {
    return false;
  }
}
